import Button from './button.js';


export default function Group (pToolbar, pGroupStruct)
{
  Group.pButtonsCommand = {};
  Group.nextGroupCountLeft = 0;
  Group.doubleSizeGroupCountLeft = 0;
  Group.groupNextLineTop = null;

  let i,
      pThis = this,
      pButtons = {},
      eGroup;

  const pGroup =
  {
    pToolbar,
    pThis,

    get pAttribute() { return pAttribute; },
    get eGroup() { return eGroup; }
  };

  const pAttribute =
        {
          name: pGroupStruct.name,
          dropdownGroup: pGroupStruct.dropdownGroup,
          openerButtonName: pGroupStruct.openerButtonName,
          id: 'idEditorToolbar_' + (pToolbar.isToolbarFloating ? pToolbar.pToolbarStructName + '_' : '') + pGroupStruct.name,
          parameters: pGroupStruct.parameters
        };

  createGroupHolder();


  function createGroupHolder()
  {
    let openerButton,
        dropdownInnerHTML;

    if (pGroupStruct.dropdownGroup)
    {
      openerButton = pToolbar.pThis.getButtonByName(pAttribute.openerButtonName);

      if (openerButton)
      {
        dropdownInnerHTML = '<div id="idDropdownInnerMainContainer" style="width: ' + pGroupStruct.Buttons[0].btnSizeWidth + 'px; float: left; background-color: #F5F5F5;"><div id="idGroup"></div></div>';
        pAttribute.Dropdown = BEditor.dropdowns.createDropdown(pAttribute.id + '_Dropdown', openerButton, pAttribute.parameters, dropdownInnerHTML);
        createDropdownGroup();
      }
    }
    else
    {
      createGroup(pToolbar.tbContainer);
    }
  }


  function createGroup (groupContainer)
  {
    eGroup = pToolbar.tDoc.createElement('DIV');

    eGroup.id = pAttribute.id;

    if (!pAttribute.dropdownGroup)
    {
      eGroup.style.position = 'absolute';
      eGroup.style.left = '-3700px';
      eGroup.style.top = '-3700px';
      eGroup.style.width = pGroupStruct.groupSizeWidth + 'px';
      eGroup.style.height = pGroupStruct.groupSizeHeight + 'px';
      eGroup.style.overflow = 'hidden';
      eGroup.style.visibility = 'hidden';
    }
    else
    {
      eGroup.style.height = (pGroupStruct.groupSizeHeight * pGroupStruct.Buttons.length) + 'px';
    }

    groupContainer.appendChild(eGroup);

    if (pGroupStruct.sepSizeWidth && pGroupStruct.sepSizeHeight)
    {
      let eSep = pToolbar.tDoc.createElement('DIV');
      eSep.style.position = 'absolute';
      eSep.style.left = '0px';
      eSep.style.top = '0px';
      eSep.style.zIndex = '1';
      eSep.style.width = pGroupStruct.sepSizeWidth + 'px';
      eSep.style.height = pGroupStruct.sepSizeHeight + 'px';
      //eSep.style[((isIE) ? 'styleFloat' : 'cssFloat')] = 'left';
      eSep.style.overflow = 'hidden';

      eGroup.appendChild(eSep);

      if (pGroupStruct.sepFileURL)
      {
        let eSepImg = pToolbar.tDoc.createElement('IMG');
        eSepImg.src = pGroupStruct.sepFileURL;
        eSepImg.width = pGroupStruct.sepSizeWidth;
        eSepImg.height = pGroupStruct.sepSizeHeight;
        eSepImg.border = '0';
        eSepImg.style.border = '0';
        eSepImg.style.border = 'none';
        eSepImg.style.background = 'none';
        eSepImg.style.padding = '0';
        eSepImg.style.margin = '0';
        eSepImg.style.cursor = 'default';

        eSep.appendChild(eSepImg);
      }

      if (pAttribute.name === 'PageLayouts' || pAttribute.name === 'EmailMacros')
      {
        eGroup.style.width = (pGroupStruct.groupSizeWidth + pGroupStruct.sepSizeWidth) + 'px';
      }
    }

    Group.nextGroupCountLeft += pGroupStruct.groupSizeWidth; // + pGroupStruct.sepSizeWidth;

    eGroup.ondragstart = function() { return false; };

    for (i = 0; i < pGroupStruct.Buttons.length; i++)
    {
      pButtons[pGroupStruct.Buttons[i].name] = new Button(pGroup, pGroupStruct.Buttons[i]);
      Group.pButtonsCommand[pGroupStruct.Buttons[i].command] = pButtons[pGroupStruct.Buttons[i].name];
    }
  }


  function createDropdownGroup()
  {
    let openerButton;

    if (pAttribute.Dropdown && pAttribute.Dropdown.isObjValid)
    {
      pToolbar.tDoc = pAttribute.Dropdown.getDocument();
      createGroup(pAttribute.Dropdown.get$('idGroup'));
      openerButton = pToolbar.pThis.getButtonByName(pAttribute.openerButtonName);

      if (openerButton)
      {
        openerButton.setAttribute('Dropdown', pAttribute.Dropdown);
      }
    }
    else
    {
      setTimeout(createDropdownGroup, 100);
    }
  }


  this.configurateGroup = function(toolbarConfig, ind)
  {
    const pGroupConfig = toolbarConfig.Groups[ind];

    if (pGroupConfig.lineBreak)
    {
      if (Group.nextGroupCountLeft > pToolbar.pToolbarStruct.singleSizeContainerWidth)
      {
        pToolbar.pToolbarStruct.singleSizeContainerWidth = Group.nextGroupCountLeft;
      }

      Group.nextGroupCountLeft = Group.doubleSizeGroupCountLeft;
      Group.groupNextLineTop += pToolbar.pToolbarStruct.singleSizeContainerHeight + ((pToolbar.pToolbarStruct.sepSizeVertical) ? pToolbar.pToolbarStruct.sepSizeVertical : 0);
    }
    else if (pGroupStruct.doubleSize)
    {
      if (Group.nextGroupCountLeft > pToolbar.pToolbarStruct.singleSizeContainerWidth)
      {
        pToolbar.pToolbarStruct.singleSizeContainerWidth = Group.nextGroupCountLeft;
      }

      Group.nextGroupCountLeft = pToolbar.pToolbarStruct.singleSizeContainerWidth;

      if (ind === 0 || Group.doubleSizeGroupCountLeft > 0)
      {
        Group.doubleSizeGroupCountLeft += pGroupStruct.groupSizeWidth;
      }
    }

    if (!pGroupConfig.isDropdown)
    {
      if (pGroupConfig.visible)
      {
        eGroup.style.left = Group.nextGroupCountLeft + 'px';
        eGroup.style.top = (pGroupStruct.doubleSize ? pToolbar.pToolbarStruct.doublePaddingTop : Group.groupNextLineTop) + 'px';
        eGroup.style.visibility = 'visible';
        Group.nextGroupCountLeft += pGroupStruct.groupSizeWidth;
      }
      else
      {
        eGroup.style.visibility = 'hidden';
        eGroup.style.left = '-3700px';
        eGroup.style.top = '-3700px';
      }
    }
  };


  this.getButtonByName = function(buttonName)
  {
    let pButton = null,
        nmButton;

    for (nmButton in pButtons)
    {
      if (pButtons.hasOwnProperty(nmButton))
      {
        pButton = pButtons[nmButton].getButtonByName(buttonName);

        if (pButton)
        {
          break;
        }
      }
    }

    return pButton;
  };


  const runButtonCommand = (command) =>
  {
    let nmButton;

    for (nmButton in pButtons)
    {
      if (pButtons.hasOwnProperty(nmButton))
      {
        pButtons[nmButton][command]();
      }
    }
  };


  this.regEditorInstance = function()
  {
    runButtonCommand('regEditorInstance');
  };


  this.unregEditorInstance = function()
  {
    runButtonCommand('unregEditorInstance');
  };


  this.refreshState = function()
  {
    runButtonCommand('refreshState');
  };


  this.closeDropdowns = function()
  {
    runButtonCommand('closeDropdown');
  };


  Object.defineProperty(this, 'pAttribute', { get: () => pAttribute});
}